import { ValueBox } from './ValueBox';
import { action, makeObservable, reaction, runInAction } from 'mobx';

export interface SnapshotParams<T, E> {
  expression: () => T;
  effect: () => E;
}

export class Snapshot<T, E> {
  readonly box;
  readonly expression;
  readonly effect;

  constructor(params: SnapshotParams<T, E>) {
    this.box = new ValueBox<E>(runInAction(() => params.effect()));
    this.expression = params.expression;
    this.effect = params.effect;

    makeObservable(this, {
      init: action,
      forceUpdate: action,
    });
  }

  get value() {
    return this.box.value;
  }

  set value(v: E) {
    this.box.value = v;
  }

  forceUpdate() {
    this.value = this.effect();
  }

  init() {
    const { box, effect } = this;
    const dispose = reaction(this.expression, () => {
      box.set(effect());
    });

    return () => {
      dispose();
    };
  }
}
